<template>
  <div class="footer">
    <div class="footer-wrapper container">
      <div class="footer-info">
        <div class="footer-info-left col-sm-8">
          <img class="logo" src="@/assets/images/r_icon_hone_bottom_logo.png">
          <div class="des">
            <div class="name">云蜂树智（厦门）信息科技有限公司</div>
            <div class="address">中国(福建)自由贸易试验区厦门片区象屿路93号厦门国际航运中心C栋4层431单元H</div>
          </div>
        </div>
        <div class="footer-info-right col-sm-4">
          <div class="row pull-right">
            <div class="name hidden-xs">联系方式</div>
            <div class="cont">
              <img src="@/assets/images/r_icon_hone_bottom_email.png" alt="">
              <div>Email:hfteam@126.com</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-copyright">© 2021 云蜂树智 闽ICP备2021006143号</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
  }
};
</script>

<style scoped lang="scss">
.footer{
  background-color: #282839;
  color: #8B8BA8;
  .footer-wrapper{
    background-color: #282839;
  }
  .footer-info{
    height: 132px;
    border-bottom: 1px solid #3A3A50;
    .footer-info-left{
      display: flex;
      align-items: center;
      margin-top: 40px;
      .logo{
        width: 41px;
        height: 46px;
      }
      .des{
        margin-left: 17px;
        .name{
          color: #fff;
          font-size: 18px;
          font-weight: bold;
        }
        .address{
          margin-top: 7px;
          font-size: 14px;
        }
      }
    }
    .footer-info-right{
      margin-top: 40px;
      .name{
        font-size: 14px;
      }
      .cont{
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #FFFFFF;
        margin-top: 10px;
        img{
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .footer-copyright{
    padding: 20px 30px;
    text-align: center;
    font-size: 12px;
    color: #585870;
  }
}
@media (max-width: $screen-sm-min) {
  .footer{
    .footer-info{
      height: auto;
      margin: 0;
      padding: 20px 0;
      .footer-info-left{
        margin: 0;
        .des{
          margin-left: 14px;
          .name{
            font-size: 16px;
          }
          .address{
            font-size: 14px;
          }
        }
      }
      .footer-info-right{
        margin-top: 10px;
        .row{
          float: none !important;
          text-align: center;
          .cont{
            justify-content: center;
            img{
              display: inline-block;
            }
            div{
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
</style>
